export const DECARB_LIBRARY_URL = {
  GetAllProjectlibraryDetails: `GetAllProjectlibraryDetails`,
  GetProjectBusinessRulesData: `GetProjectBusinessRulesData`,
  GetBusinessCaseSummaryData: `GetBusinessCaseSummaryData`,
  GetFinancialsAbatementData: `GetFinancialsAbatementDataAsync`,
  AddProjecttoProjectLibrary: `AddProjecttoProjectLibraryAsync`,
  GetGMPTableData: `GetGMPTableData`,
};
